import React, { useEffect, useState, useMemo } from "react";

function ProfitLossDetailedNew(props) {

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";
    const { datagetTrialBalanceReport, parentDetails, selected_mode_table_structure } = props;
    const [expandedNodes, setExpandedNodes] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});

    useEffect(() => {
        if (datagetTrialBalanceReport) {
            const allNodes = {};
            const allGroups = {};

            datagetTrialBalanceReport.forEach((row) => {
                allNodes[row.NODE] = true;
                const groupKey = `${row.NODE}_${row["GROUP CODE"]}`;
                allGroups[groupKey] = true;
            });

            setExpandedNodes(allNodes);
            setExpandedGroups(allGroups);
        }
    }, [datagetTrialBalanceReport]);

    // Visible columns excluding NODE and GROUP CODE
    const visibleColumns = useMemo(() => {
        const selectedModeName = parentDetails?.mode_list_array?.find((item) => item.is_selected)?.mode_name;
        return selected_mode_table_structure?.find(
            (item) => item.mode_table_name === selectedModeName
        )?.mode_table_columns?.filter(
            (col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "GROUP CODE"
        ) || [];
    }, [parentDetails, selected_mode_table_structure]);

    // colSpan calculation for labels (everything before DEBIT)
    const labelColSpan = useMemo(() => {
        const debitIndex = visibleColumns.findIndex((col) => col.column_key_from_api === "DEBIT");
        return debitIndex > 0 ? debitIndex : 1;
    }, [visibleColumns]);

    return (
        <div className="min-h-screen bg-gray-200 py-10 px-4">
            <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-none border border-gray-300 px-4 pt-4 pb-6 overflow-x-auto">
                
                {/* Header Title Banner */}
                <div>

                    <div>


                        {apiPaths_from_local_storage[0]?.REP_HEADER?.includes("data:image/") && (
                            <img
                                src={apiPaths_from_local_storage[0].REP_HEADER}
                            />
                        )}

                    </div>

                    <div style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        color: '#0f172a',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        margin: '20px 0',
                        padding: '10px 16px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '6px'
                    }}>
                        {
                            selected_mode_table_structure.find(
                                (item) => item.mode_table_code === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_code
                            )?.mode_table_name
                        }
                    </div>

                </div>

                <table className="min-w-full divide-y divide-gray-200 text-sm mt-3">
                    <thead className="border-b-2 border-gray-900">
                        <tr>
                            {visibleColumns.map((item, i) => (
                                <th
                                    key={i}
                                    className={`px-4 py-2 text-xs font-bold text-gray-900 uppercase tracking-wider ${
                                        ["DEBIT", "CREDIT", "BALANCE"].includes(item.column_key_from_api)
                                            ? "text-right"
                                            : "text-left"
                                    }`}
                                >
                                    {item.column_name}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100">
                        {(() => {
                            if (!datagetTrialBalanceReport) return null;

                            // Grand total calculation
                            const grandTotal = datagetTrialBalanceReport.reduce(
                                (acc, r) => ({
                                    DEBIT: acc.DEBIT + (r.DEBIT || 0),
                                    CREDIT: acc.CREDIT + (r.CREDIT || 0),
                                    BALANCE: acc.BALANCE + (r.BALANCE || 0),
                                }),
                                { DEBIT: 0, CREDIT: 0, BALANCE: 0 }
                            );

                            // Precompute node subtotals for Gross Profit
                            const nodeTotals = datagetTrialBalanceReport.reduce((acc, row) => {
                                if (!acc[row.NODE]) {
                                    acc[row.NODE] = { DEBIT: 0, CREDIT: 0, BALANCE: 0 };
                                }
                                acc[row.NODE].DEBIT += (row.DEBIT || 0);
                                acc[row.NODE].CREDIT += (row.CREDIT || 0);
                                acc[row.NODE].BALANCE += (row.BALANCE || 0);
                                return acc;
                            }, {});

                            const incomeNodeKey = Object.keys(nodeTotals).find(n => {
                                if (!n) return false;
                                const lower = n.toLowerCase();
                                return lower.includes('income') || lower.includes('sales') || lower.includes('revenue') || lower === 'turnover';
                            });
                            const cogsNodeKey = Object.keys(nodeTotals).find(n => {
                                if (!n) return false;
                                const lower = n.toLowerCase();
                                return lower === 'cogs' || lower.includes('cogs') || lower.includes('cost of') || lower.includes('direct cost') || lower.includes('direct exp') || lower.includes('purchases');
                            });

                            const grossProfit = {
                                BALANCE: (incomeNodeKey ? nodeTotals[incomeNodeKey].BALANCE : 0) + (cogsNodeKey ? nodeTotals[cogsNodeKey].BALANCE : 0),
                            };

                            return (
                                <>
                                    {Object.entries(
                                        datagetTrialBalanceReport.reduce((acc, row) => {
                                            if (!acc[row.NODE]) acc[row.NODE] = {};
                                            if (!acc[row.NODE][row["GROUP CODE"]])
                                                acc[row.NODE][row["GROUP CODE"]] = [];
                                            acc[row.NODE][row["GROUP CODE"]].push(row);
                                            return acc;
                                        }, {})
                                    ).map(([node, groups], nodeIndex) => {
                                        const nodeSubtotal = Object.values(groups)
                                            .flat()
                                            .reduce(
                                                (acc, r) => ({
                                                    DEBIT: acc.DEBIT + (r.DEBIT || 0),
                                                    CREDIT: acc.CREDIT + (r.CREDIT || 0),
                                                    BALANCE: acc.BALANCE + (r.BALANCE || 0),
                                                }),
                                                { DEBIT: 0, CREDIT: 0, BALANCE: 0 }
                                            );

                                        return (
                                            <React.Fragment key={nodeIndex}>
                                                {/* NODE HEADER */}
                                                <tr
                                                    className="border-t border-gray-200 cursor-pointer hover:bg-gray-50"
                                                    onClick={() =>
                                                        setExpandedNodes((prev) => ({ ...prev, [node]: !prev[node] }))
                                                    }
                                                >
                                                    <td
                                                        colSpan={visibleColumns.length}
                                                        className="px-4 py-2 font-bold text-gray-900 text-sm flex items-center gap-2 uppercase tracking-wide"
                                                    >
                                                        <span className={`transition-transform duration-200 ${expandedNodes[node] ? "rotate-90" : ""}`}>
                                                            ▶
                                                        </span>
                                                        {node.replace(/^[0-9.]+\s*/, '')}
                                                    </td>
                                                </tr>

                                                {/* GROUPS UNDER NODE */}
                                                {expandedNodes[node] &&
                                                    Object.entries(groups).map(([groupCode, rows], groupIndex) => {
                                                        const groupSubtotal = rows.reduce(
                                                            (acc, r) => ({
                                                                DEBIT: acc.DEBIT + (r.DEBIT || 0),
                                                                CREDIT: acc.CREDIT + (r.CREDIT || 0),
                                                                BALANCE: acc.BALANCE + (r.BALANCE || 0),
                                                            }),
                                                            { DEBIT: 0, CREDIT: 0, BALANCE: 0 }
                                                        );
                                                        const groupKey = `${node}_${groupCode}`;

                                                        return (
                                                            <React.Fragment key={groupIndex}>
                                                                {/* GROUP HEADER */}
                                                                <tr
                                                                    className="border-t border-gray-100 cursor-pointer hover:bg-gray-50 text-gray-800"
                                                                    onClick={() =>
                                                                        setExpandedGroups((prev) => ({
                                                                            ...prev,
                                                                            [groupKey]: !prev[groupKey],
                                                                        }))
                                                                    }
                                                                >
                                                                    <td
                                                                        colSpan={visibleColumns.length}
                                                                        className="pl-8 pr-4 py-1.5 font-semibold text-xs flex items-center gap-2 uppercase tracking-wider text-gray-700"
                                                                    >
                                                                        <span className={`transition-transform duration-200 ${expandedGroups[groupKey] ? "rotate-90" : ""}`}>
                                                                            ▶
                                                                        </span>
                                                                        Group Code: {groupCode}
                                                                    </td>
                                                                </tr>

                                                                {/* ACCOUNTS UNDER GROUP */}
                                                                {expandedGroups[groupKey] &&
                                                                    rows.map((row, i) => (
                                                                        <tr key={i} className="hover:bg-gray-50">
                                                                            {visibleColumns.map((col, ci) => {
                                                                                const key = col.column_key_from_api;
                                                                                return (
                                                                                    <td
                                                                                        key={ci}
                                                                                        className={`px-4 py-1.5 text-sm ${
                                                                                            ["DEBIT", "CREDIT", "BALANCE"].includes(key)
                                                                                                ? "text-right tabular-nums font-mono"
                                                                                                : "text-left text-gray-700"
                                                                                        }`}
                                                                                    >
                                                                                        {row[key]}
                                                                                    </td>
                                                                                );
                                                                            })}
                                                                        </tr>
                                                                    ))}

                                                                {/* GROUP SUBTOTAL */}
                                                                {expandedGroups[groupKey] && (
                                                                    <tr className="border-t border-dashed border-gray-200 font-medium text-xs">
                                                                        <td colSpan={labelColSpan} className="pl-12 pr-4 py-1.5 italic text-gray-500">
                                                                            Subtotal — {groupCode}
                                                                        </td>
                                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-blue-700">
                                                                            {groupSubtotal.DEBIT.toFixed(2)}
                                                                        </td>
                                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-emerald-700">
                                                                            {groupSubtotal.CREDIT.toFixed(2)}
                                                                        </td>
                                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-gray-700">
                                                                            {groupSubtotal.BALANCE.toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}

                                                {/* NODE SUBTOTAL */}
                                                {expandedNodes[node] && (
                                                    <tr className="border-t border-dashed border-gray-300 font-medium text-xs">
                                                        <td colSpan={labelColSpan} className="px-4 py-2 italic text-gray-600 font-semibold">
                                                            Node Total — {node.replace(/^[0-9.]+\s*/, '')}
                                                        </td>
                                                        <td className="px-4 py-2 text-right tabular-nums font-mono text-blue-700 font-semibold">
                                                            {nodeSubtotal.DEBIT.toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-2 text-right tabular-nums font-mono text-emerald-700 font-semibold">
                                                            {nodeSubtotal.CREDIT.toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-2 text-right tabular-nums font-mono text-gray-700 font-semibold">
                                                            {nodeSubtotal.BALANCE.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}

                                                {/* GROSS PROFIT / LOSS ROW */}
                                                {(node === (cogsNodeKey || incomeNodeKey)) && (
                                                    <tr className={`${grossProfit.BALANCE < 0 ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'} font-bold border-t border-b`}>
                                                        {visibleColumns.map((col, ci, arr) => {
                                                            const isBalance = col.column_key_from_api === "BALANCE";
                                                            const balanceIndex = arr.findIndex(c => c.column_key_from_api === "BALANCE");
                                                            const textIndex = balanceIndex > 0 ? balanceIndex - 1 : 0;

                                                            if (ci === textIndex) {
                                                                return (
                                                                    <td key={ci} className={`px-4 py-2 font-bold text-right text-xs uppercase tracking-wide ${grossProfit.BALANCE < 0 ? 'text-green-900' : 'text-red-900'}`}>
                                                                        {grossProfit.BALANCE < 0 ? 'Gross Profit' : 'Gross Loss'}
                                                                    </td>
                                                                );
                                                            }
                                                            if (isBalance) {
                                                                return (
                                                                    <td key={ci} className={`px-4 py-2 font-bold tabular-nums font-mono text-right text-xs ${grossProfit.BALANCE < 0 ? 'text-green-900' : 'text-red-900'}`}>
                                                                        {Math.abs(grossProfit.BALANCE).toFixed(2)}
                                                                    </td>
                                                                );
                                                            }
                                                            return <td key={ci} className="px-4 py-2"></td>;
                                                        })}
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}

                                    {/* GRAND TOTAL / NET PROFIT OR LOSS */}
                                    <tr className="font-bold text-sm" style={{ borderTop: "3px double #111827" }}>
                                        {visibleColumns.map((col, ci, arr) => {
                                            const isBalance = col.column_key_from_api === "BALANCE";
                                            const balanceIndex = arr.findIndex(c => c.column_key_from_api === "BALANCE");
                                            const textIndex = balanceIndex > 0 ? balanceIndex - 1 : 0;

                                            if (ci === textIndex) {
                                                return (
                                                    <td key={ci} className="px-4 py-3 text-right text-gray-900 uppercase tracking-wide text-xs">
                                                        {grandTotal.BALANCE < 0 ? 'Net Profit' : 'Net Loss'}
                                                    </td>
                                                );
                                            }
                                            if (isBalance) {
                                                return (
                                                    <td key={ci} className={`px-4 py-3 text-right tabular-nums font-mono ${grandTotal.BALANCE < 0 ? 'text-green-700' : 'text-red-700'}`}>
                                                        {Math.abs(grandTotal.BALANCE).toFixed(2)}
                                                    </td>
                                                );
                                            }
                                            return <td key={ci} className="px-4 py-3"></td>;
                                        })}
                                    </tr>
                                </>
                            );
                        })()}
                    </tbody>
                </table>

                {/* Report Footer */}
                <div className="mt-8">
                    <div className="border-t-2 border-gray-900" />
                    <div className="mt-0.5 border-t border-gray-300" />
                    <div className="mt-4 flex justify-between items-center">
                        <p className="text-xs text-gray-400">
                            Generated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ProfitLossDetailedNew;